module.exports = __webpack_public_path__ + "66a9808e2d3f58dff37e619e3f2260ed.woff";